"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.submitTokenSaga = exports.requestTokenSaga = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _actions = require("./actions");

var _auth = require("../../../graphql/mutations/auth");

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(callSequence);

function callSequence(fns) {
  var _len,
      args,
      _key,
      _iteratorNormalCompletion,
      _didIteratorError,
      _iteratorError,
      _iterator,
      _step,
      fn,
      _args = arguments;

  return _regenerator["default"].wrap(function callSequence$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          for (_len = _args.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = _args[_key];
          }

          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 4;
          _iterator = fns[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 14;
            break;
          }

          fn = _step.value;

          if (!fn) {
            _context.next = 11;
            break;
          }

          _context.next = 11;
          return _effects.call.apply(void 0, [fn].concat(args));

        case 11:
          _iteratorNormalCompletion = true;
          _context.next = 6;
          break;

        case 14:
          _context.next = 20;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](4);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 20:
          _context.prev = 20;
          _context.prev = 21;

          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }

        case 23:
          _context.prev = 23;

          if (!_didIteratorError) {
            _context.next = 26;
            break;
          }

          throw _iteratorError;

        case 26:
          return _context.finish(23);

        case 27:
          return _context.finish(20);

        case 28:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[4, 16, 20, 28], [21,, 23, 27]]);
}

var requestTokenSaga =
/*#__PURE__*/
_regenerator["default"].mark(function _requestTokenSaga() {
  var options,
      _ref,
      promiseDispatcher,
      phone,
      action,
      client,
      onError,
      onSuccess,
      _ref2,
      response,
      _args2 = arguments;

  return _regenerator["default"].wrap(function _requestTokenSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref = _args2.length > 1 ? _args2[1] : undefined, promiseDispatcher = _ref.promiseDispatcher, phone = _ref.phone, action = (0, _objectWithoutProperties2["default"])(_ref, ["promiseDispatcher", "phone"]);
          _context2.next = 4;
          return (0, _effects.getContext)('apolloClient');

        case 4:
          client = _context2.sent;
          onError = [options.onError, action.onError, promiseDispatcher.reject];
          onSuccess = [options.onSuccess, action.onSuccess, promiseDispatcher.resolve];
          _context2.prev = 7;
          _context2.next = 10;
          return (0, _effects.call)([client, client.mutate], {
            mutation: _auth.REQUEST_TOKEN_MUTATION,
            variables: {
              phone: "+55".concat(phone)
            }
          });

        case 10:
          _ref2 = _context2.sent;
          response = _ref2.data.signInCreateAuthenticationCode;

          if (!(response.enqueued === 'SUCCESS')) {
            _context2.next = 16;
            break;
          }

          return _context2.delegateYield(callSequence(onSuccess), "t0", 14);

        case 14:
          _context2.next = 17;
          break;

        case 16:
          return _context2.delegateYield(callSequence(onError, {
            response: response,
            message: 'unexpected response returned'
          }), "t1", 17);

        case 17:
          _context2.next = 22;
          break;

        case 19:
          _context2.prev = 19;
          _context2.t2 = _context2["catch"](7);
          return _context2.delegateYield(callSequence(onError, _context2.t2), "t3", 22);

        case 22:
        case "end":
          return _context2.stop();
      }
    }
  }, _requestTokenSaga, null, [[7, 19]]);
});

exports.requestTokenSaga = requestTokenSaga;

var submitTokenSaga =
/*#__PURE__*/
_regenerator["default"].mark(function _submitTokenSaga() {
  var options,
      _ref3,
      promiseDispatcher,
      phone,
      token,
      action,
      client,
      onError,
      onSuccess,
      _ref4,
      response,
      _args3 = arguments;

  return _regenerator["default"].wrap(function _submitTokenSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref3 = _args3.length > 1 ? _args3[1] : undefined, promiseDispatcher = _ref3.promiseDispatcher, phone = _ref3.phone, token = _ref3.token, action = (0, _objectWithoutProperties2["default"])(_ref3, ["promiseDispatcher", "phone", "token"]);
          _context3.next = 4;
          return (0, _effects.getContext)('apolloClient');

        case 4:
          client = _context3.sent;
          onError = [options.onError, action.onError, promiseDispatcher.reject];
          onSuccess = [options.onSuccess, action.onSuccess, promiseDispatcher.resolve];
          _context3.prev = 7;
          _context3.next = 10;
          return (0, _effects.call)([client, client.mutate], {
            mutation: _auth.SUBMIT_TOKEN_MUTATION,
            variables: {
              phone: "+55".concat(phone),
              code: token
            }
          });

        case 10:
          _ref4 = _context3.sent;
          response = _ref4.data.signInVerifyAuthenticationCode;
          return _context3.delegateYield(callSequence(onSuccess, response.jwt, response.user), "t0", 13);

        case 13:
          _context3.next = 18;
          break;

        case 15:
          _context3.prev = 15;
          _context3.t1 = _context3["catch"](7);
          return _context3.delegateYield(callSequence(onError, _context3.t1), "t2", 18);

        case 18:
        case "end":
          return _context3.stop();
      }
    }
  }, _submitTokenSaga, null, [[7, 15]]);
});

exports.submitTokenSaga = submitTokenSaga;

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (
    /*#__PURE__*/
    _regenerator["default"].mark(function authSaga() {
      return _regenerator["default"].wrap(function authSaga$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _effects.all)([(0, _effects.takeLatest)(_actions.TYPES.EM_CASA_REQUEST_TOKEN, requestTokenSaga, options), (0, _effects.takeLatest)(_actions.TYPES.EM_CASA_SUBMIT_TOKEN, submitTokenSaga, options)]);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, authSaga);
    })
  );
};

exports["default"] = _default;